import { createContext } from 'react';

const controlGLBContext = createContext();

export default controlGLBContext;